var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "callout mt-2",
      attrs: { "has-border": false, "has-toggle": true },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c("div", { staticClass: "mx-2 mx-md-4 mx-3" }, [
                _c(
                  "div",
                  { staticClass: "bg-white border-radius--light py-2 px-4" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 mb-3" }, [
                        _c("em", {
                          staticClass: "fas fa-info-circle text-orange mr-1"
                        }),
                        _c("span", [_vm._v("Información Adicional")])
                      ]),
                      _c("div", { staticClass: "col-12 mb-4" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Justificación:")
                        ]),
                        _c("span", { staticClass: "info" }, [
                          _vm._v(" " + _vm._s(_vm.value.justification) + " ")
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("custom-separator", {
                            staticClass: "separation-of-funds__separator my-4",
                            attrs: { text: "Cifra de Cuenta" }
                          }),
                          _vm._l(_vm.value.accountNumbers, function(
                            accountNumber
                          ) {
                            return _c("account-number", {
                              key: `accountNumber-${accountNumber.purchaseOrderNumberId}`,
                              staticClass: "mb-3",
                              attrs: {
                                "bg-color": "bg-secondary-3",
                                "can-remove": false,
                                "is-read-only": true,
                                value: accountNumber
                              }
                            })
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row mt-2 row-container py-4" }, [
        _c("div", { staticClass: "col-md-2 col-12 border-right status" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Número:")]),
              _c("span", { staticClass: "info font-weight-bold" }, [
                _vm._v(" " + _vm._s(_vm.value.separationFundNumber) + " ")
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-10" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Contratación:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.contractTypeName) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Fecha Hasta:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("date")(_vm.value.contractDateTo)) + " "
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Monto:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm._f("price")(_vm.value.cost)) + " ")
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-12 col-md-2" },
              [
                _vm.showSeparationFundsReportsButton
                  ? _c("dropdown", {
                      staticClass: "actions-dropdown",
                      attrs: {
                        items: _vm.actionsDropdown,
                        responsive: "",
                        title: "Acciones"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }